import perMeterCalc from '../../utils/perMeterCalc'

export default function(i, size, minSizes, maxSizes, perMeter) {
  const min = perMeterCalc(minSizes[i], perMeter) - 10
  const max = perMeterCalc(maxSizes[i], perMeter) + 10

  if (size < min) {
    return min
  }
  if (size > max) {
    return max
  }

  return size
}



// WEBPACK FOOTER //
// ./src/components/ResizableProduct/calc.js